import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Section, Reveal, Eyebrow } from "./blocks";
import { BLOG_POSTS, formatDate } from "../data/blog";
import { OptImg } from "@/components/OptImg";

export default function LatestInsight() {
  const p = BLOG_POSTS[0];
  if (!p) return null;
  return (
    <Section bg="bg-ink">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <Eyebrow>Latest Insight</Eyebrow>
          <Link
            to={`/blog/${p.slug}`}
            data-testid="latest-insight-card"
            className="group mt-6 grid sm:grid-cols-[240px_1fr] gap-0 sm:gap-6 bg-surface rounded-2xl overflow-hidden transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="relative aspect-[3/2] sm:aspect-auto overflow-hidden">
              <OptImg sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw" loading="lazy" src={p.heroImage} alt={p.heroAlt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-6 sm:pr-8 flex flex-col justify-center">
              <p className="font-eyebrow text-ember text-[11px]">{p.category}</p>
              <h3 className="font-display text-xl text-white leading-snug mt-2">{p.title}</h3>
              <p className="text-white/40 text-xs mt-3">{formatDate(p.datePublished)} · {p.readTime}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-embersoft text-sm">Read <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" /></span>
            </div>
          </Link>
        </Reveal>
      </div>
    </Section>
  );
}
